import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

/**
 * Higher-Order Component to provide React Router v6 hooks to class components
 * @param {React.Component} WrappedComponent - The component to wrap
 * @returns {React.Component} - The wrapped component with router props
 */
export function withRouter(WrappedComponent) {
  function WithRouterComponent(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    // Create a history-like object for backward compatibility
    const router = {
      navigate,
      location,
      push: (path) => navigate(path),
      replace: (path) => navigate(path, { replace: true }),
    };

    return (
      <WrappedComponent
        {...props}
        navigate={navigate}
        location={location}
        params={params}
        router={router}
      />
    );
  }

  WithRouterComponent.displayName = `withRouter(${
    WrappedComponent.displayName || WrappedComponent.name
  })`;

  return WithRouterComponent;
}
